var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.666 1.667H3.333c-.917 0-1.667.75-1.667 1.666v10c0 .917.75 1.667 1.667 1.667H15l3.333 3.333v-15c0-.916-.75-1.666-1.666-1.666zM15 13.333H4.166a.836.836 0 0 1-.833-.833V4.167c0-.459.375-.834.833-.834h11.667c.458 0 .833.375.833.834V15L15 13.333zm-10-7.5c0-.46.373-.833.833-.833h8.334a.833.833 0 0 1 0 1.667H5.832A.833.833 0 0 1 5 5.833zM5.833 7.5a.833.833 0 0 0 0 1.667h8.334a.833.833 0 0 0 0-1.667H5.832zm0 2.5a.833.833 0 1 0 0 1.667h8.334a.833.833 0 1 0 0-1.667H5.832z",
    fill: "#546B7E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.073ca24f.svg";
export { ForwardRef as ReactComponent };